import { SelectOption } from "../../../molecule/inputs/select-input"
import SearchSelect from "Components/molecule/inputs/search-select"
import { CSSProperties } from "react"
import TextInput from "Components/molecule/inputs/text-input"
import { IEmployeeQueryParams } from 'models/employee';
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import useEnterSearch from "hooks/useEnterSearch"
import SearchFormContainer from "Components/atoms/containers/search-form-container"


interface SearchDocumentTemplateProps {
    handleChangeQuery: (key: keyof IEmployeeQueryParams, value: any) => any,
    query: IEmployeeQueryParams,
    jobTitles: SelectOption[]
    managers: SelectOption[]
    departments: SelectOption[]
    provinces: SelectOption[]
    status: SelectOption[]
    employeeTypes: SelectOption[]
    handleClearSearch: () => any
    handleSearch: () => any
    isSearching?: boolean
    style?: CSSProperties,
    hide?: {
        employeeType?: boolean
    },
}

const SearchEmployeesForm = ({
    jobTitles,
    managers,
    departments,
    provinces,
    status,
    employeeTypes,
    handleClearSearch,
    handleSearch,
    isSearching,
    handleChangeQuery,
    query,
    style,
    hide
}: SearchDocumentTemplateProps) => {
    // Enter in a text box searches too
    const { inputProps, selectProps } = useEnterSearch(handleSearch)
    return (
        <SearchFormContainer
            style={style}
            inputs={
                <>
                    <TextInput
                        label="Code"
                        value={query.employeeCode ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("employeeCode", e?.target.value ?? "")
                        }
                        placeholder="e.g. EMP001"
                        {...inputProps}
                    />

                    <TextInput
                        label="Name"
                        value={query.name ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("name", e?.target.value ?? "")
                        }
                        placeholder="Name"
                        {...inputProps}
                    />

                    <SearchSelect
                        label="Job Title"
                        value={query.jobTitleId ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("jobTitleId", e?.value ?? "")
                        }
                        options={jobTitles}
                        placeholder="All"
                        {...selectProps}
                    />

                    <SearchSelect
                        label="Department"
                        value={query.departmentId ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("departmentId", e?.value ?? "")
                        }
                        options={departments}
                        placeholder="All"
                        {...selectProps}
                    />

                    <SearchSelect
                        label="Manager"
                        value={query.managerId ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("managerId", e?.value ?? "")
                        }
                        options={managers}
                        placeholder="All"
                        {...selectProps}
                    />
                    {
                        !hide?.employeeType &&
                        <SearchSelect
                            label="Employee Type"
                            value={query.employeeTypeId && query.employeeTypeId.length > 0 ? query.employeeTypeId[0] : ""}
                            onChange={(e) =>
                                handleChangeQuery("employeeTypeId", e?.value ? [e.value] : "")
                            }
                            options={employeeTypes}
                            placeholder="All"
                            {...selectProps}
                        />
                    }


                    <SearchSelect
                        label="Province"
                        value={query.province ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("province", e?.value ?? "")
                        }
                        options={provinces}
                        placeholder="All"
                        {...selectProps}
                    />

                    <SearchSelect
                        label="Employment Status"
                        value={query.statusId ?? ""}
                        onChange={(e) =>
                            handleChangeQuery("statusId", e?.value ?? "")
                        }
                        options={status}
                        placeholder="All"
                        {...selectProps}
                    />
                </>
            }
            clearSearchButton={
                <>
                    <PrimaryButton disabled={isSearching} onClick={handleSearch}>
                        {isSearching ? 'Searching...' : 'Search'}
                    </PrimaryButton>
                    <SecondaryButton disabled={isSearching} onClick={handleClearSearch}>
                        Clear Search
                    </SecondaryButton>
                </>
            }
        />
    )

}

export default SearchEmployeesForm